import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { LoggingService } from "./logging.service";
import environment from "../../environments/static";
import { Store } from "@ngrx/store";
import { AppState } from "../state";

const performCookieRenewals = environment.compiled;
const renewThreshold = 10 * 60 * 1000; // 10 minutes

@Injectable({
    providedIn: "root",
})
export class IdleMonitorService {
    private renewingToken = false;
    private lastActivityTime: number;
    private idleCheckerId: number | null = null;
    private stateSubscription: any = null;

    constructor(
        private loggingService: LoggingService,
        private loginService: LoginService,
        private store: Store<AppState>
    ) {}

    start() {
        if (this.idleCheckerId !== null) {
            console.debug("IdleMonitorService already started!");
            return;
        }

        if (performCookieRenewals) {
            this.lastActivityTime = Date.now();
            this.idleCheckerId = 1; // Mark as started

            // Subscribe to NgRx state changes to detect user activity
            this.stateSubscription = this.store.subscribe(() => {
                this.onStateChange();
            });
        }
    }

    stop() {
        if (this.idleCheckerId === null) {
            console.debug("IdleMonitorService already stopped!");
            return;
        }

        if (performCookieRenewals) {
            window.clearInterval(this.idleCheckerId);
            this.idleCheckerId = null;

            if (this.stateSubscription) {
                this.stateSubscription.unsubscribe();
                this.stateSubscription = null;
            }
        }
    }

    private async onStateChange(): Promise<void> {
        if (this.idleCheckerId === null || this.renewingToken) return;

        const timeSinceLastRefresh = Date.now() - this.lastActivityTime;
        if (timeSinceLastRefresh < renewThreshold) return;

        try {
            this.renewingToken = true;
            await this.loginService.renewToken();
            this.lastActivityTime = Date.now();
        } catch (error) {
            this.loggingService.logTrace(
                `Failed to renew token for user ${
                    this.loginService.currentIdentity?.username ?? "<unknown>"
                }`
            );
        } finally {
            this.renewingToken = false;
        }
    }
}
